import React, { useEffect, useState } from "react";
import { Box, Button, Grid, IconButton, TextField } from "@mui/material";
import { Clear } from "@mui/icons-material";
import Admin from "../Dashboard";
import { RobotoTypo } from "../../../utils/Typographies";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import DeleteSchoolModal from "../School/DeleteSchoolModal";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const rows = [
  { id: 1, title: "Title 1", description: "Description 1" },
  { id: 2, title: "Title 2", description: "Description 2" },
  { id: 3, title: "Title 3", description: "Description 3" },
  // Add more rows as needed
];

export default function TeamList() {
  const navigate = useNavigate();
  const [teamList, setTeamList] = useState([]);
  const location = useLocation();
  const teamType = location?.pathname.replace("/admin/", "");
  const [open, setOpen] = useState(false);
  const [deleteSchool, setDeleteSchool] = useState("");
  const [deleteSchoolId, setDeleteSchoolId] = useState("");

  const getTeamByType = () => {
    const obj = {
      singaporeTeam: "getSingaporeTeam",
      taiwanTeam: "getTaiwanTeam",
      hongKongTeam: "getHongKongTeam",
      chinaTeam: "getChinaTeam",
    };
    return obj[teamType];
  };

  const getTeam = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/${getTeamByType()}`
      );
      console.log("response get ", response);
      if (response.status == 200) {
        if (Array.isArray(response?.data)) {
          setTeamList(response?.data != "" ? response?.data : []);
        } else if (
          typeof response?.data === "object" &&
          response?.data !== null
        ) {
          setTeamList(response?.data != "" ? [response?.data] : []);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    setTeamList([]);
    getTeam();
  }, [teamType]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/deletePersonById/${id}`,
        {
          headers: {
            Authorization: localStorage.getItem("admin_token"),
          },
        }
      );
      if (response.status == 200) {
        getTeam();
      }
    } catch (error) {
      if (error.response.status == 403) {
        localStorage.clear();
        navigate("/admin/login");
      }
    }
  };
  const handleEdit = (id) => {
    navigate(`/admin/${teamType}/` + id);
  };
  const handleDeleteSchool = (school, schoolId) => {
    setDeleteSchool(school);
    setDeleteSchoolId(schoolId);
    setOpen(true);
  };

   // Handle drag end
    const handleDragEnd = async (result) => {
      if (!result.destination) return; // dropped outside
  
      const sourceIndex = result.source.index;
      const destinationIndex = result.destination.index;
  
      // If dropped in the same position, do nothing
      if (sourceIndex === destinationIndex) return;
  
      // Copy current list
      const updated = Array.from(teamList);
  
      // Remove moved item and insert at new index
      const [moved] = updated.splice(sourceIndex, 1);
      updated.splice(destinationIndex, 0, moved);
  
      // Recalculate order values (1-based)
      const reordered = updated.map((item, idx) => ({
        ...item,
        order: idx + 1,
      }));
  
      // Optimistically update UI
      setTeamList(reordered);
  
      // Prepare payload (only necessary fields)
      const payload = reordered.map((it) => ({ _id: it._id, order: it.order }));
  
      try {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/reorderSingaporeTeams`, 
          { items: payload }, 
          {
            headers: {
              Authorization: localStorage.getItem("admin_token"),
            },
          }
        );
      } catch (err) {
        console.error("Failed to save new order", err);
        // If persist fails, revert by refetching
        getTeam();
      }
    };

  return (
    <Admin>
      <DeleteSchoolModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        school={deleteSchool}
        handleDelete={handleDelete}
        deleteSchoolId={deleteSchoolId}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          mb: 1,
        }}
      >
        <Button
          component="span"
          onClick={() => navigate(`/admin/${teamType}/add`)}
          variant="contained"
          sx={{
            alignSelf: "center",
            mt: 1,
            width: "fit-content",
            backgroundColor: "#177D84",
            "&:hover": { backgroundColor: "#177D84" },
          }}
        >
          Add
        </Button>
      </Box>

      <DragDropContext onDragEnd={handleDragEnd}>
        <TableContainer component={Paper}>
          <Table aria-label="Higher Officials Table" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell width="5%">Sno</TableCell>
                <TableCell width="10%">Drag</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <Droppable droppableId="higherOfficialsDroppable">
              {(provided) => (
                <TableBody
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {teamList?.length > 0 &&
                    teamList.map((team, index) => (
                      <Draggable
                        key={team._id}
                        draggableId={String(team._id)}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <TableRow
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            sx={{
                              background: snapshot.isDragging 
                                ? "rgba(25, 118, 210, 0.08)" 
                                : "inherit",
                              '&:hover': {
                                backgroundColor: snapshot.isDragging 
                                  ? "rgba(25, 118, 210, 0.12)" 
                                  : "rgba(0, 0, 0, 0.04)",
                              },
                              transition: 'background-color 0.2s ease',
                            }}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              <div {...provided.dragHandleProps} 
                                style={{ 
                                  cursor: 'grab',
                                  display: 'inline-block',
                                  padding: '4px'
                                }}
                              >
                                ⋮⋮
                              </div>
                            </TableCell>
                            <TableCell>{team?.en?.person_name}</TableCell>
                            <TableCell>{team?.en?.role_name}</TableCell>
                            <TableCell align="right">
                              <IconButton
                                aria-label="delete"
                                onClick={() => handleDeleteSchool(team?.en?.name, team._id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                              <IconButton
                                aria-label="edit"
                                onClick={() => handleEdit(team._id)}
                              >
                                <EditIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </TableBody>
              )}
            </Droppable>
          </Table>
        </TableContainer>
      </DragDropContext>
    </Admin>
  );
}
